// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box } from '@mui/material';

/* import WelcomeOverlay from './components/WelcomeOverlay'; // Import the WelcomeOverlay component */

import { ChannelDetail, VideoDetail, SearchFeed, Navbar, Feed } from './components';

const App = () => (
  <BrowserRouter>
    <Box sx={{ backgroundColor: 'rgb(15,15,20)' }}>

      {/* Display WelcomeOverlay */}
      {/* <WelcomeOverlay /> */}
      {/* Display WelcomeOverlay */}

      <Navbar />
      <Routes>
        <Route exact path='/' element={<Feed />} />
        <Route path='/video/:id' element={<VideoDetail />} />
        <Route path='/channel/:id' element={<ChannelDetail />} />
        <Route path='/search/:searchTerm' element={<SearchFeed />} />
      </Routes>
    </Box>
  </BrowserRouter>
);

export default App; 
// src/App.js
